import { OTP_TTL_MS } from "@sajilni/config";

/** True when `createdAt` is older than the OTP lifetime. `nowMs` is for tests. */
export const isOtpExpired = (createdAt: Date, nowMs = Date.now()) =>
  nowMs - createdAt.getTime() > OTP_TTL_MS;
